import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { NewAccountStackRoutes, NewAccountStackScreenProps } from './type';
import { NewAccountWebOneScreen } from './NewAccountWebOne.screen';
import { NewAccountNativeOneScreen } from './NewAccountNativeOne.screen';

export const NewAccountConfirm: React.FC<NewAccountStackScreenProps<NewAccountStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, func, onReturnData, refresh, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <NewAccountNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <NewAccountWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
    />
  );
};
